module.exports = __webpack_public_path__ + "static/media/import_learningScore2.b621cf43.xlsx";